import { isNullish } from "@ac-expo/utils";
import { ChatCircleIcon, HeartIcon, ShareFatIcon } from "@phosphor-icons/react";
import UserAvatar from "../UserAvatar";
import { CondensedStructureType } from "./StructureDetails";
import { StructureSocialsSection } from "./StructureContactSection";

export const StructureNameSection = ({
  structureImageUrl,
  structure,
  onConversationClick,
  isLiked,
  onShareClick,
  toggleLike,
  isEmbedded,
  actionGuard,
  onSocialsClick,
}: {
  structureImageUrl?: string;
  structure: CondensedStructureType;
  onConversationClick: () => void;
  isLiked?: boolean;
  onShareClick?: () => void;
  toggleLike?: () => void;
  isEmbedded?: boolean;
  actionGuard?: (action: () => void, fallback?: () => void, ignoreModal?: boolean) => void;
  onSocialsClick?: () => void;
}) => {
  const { businessName, businessSectorRelation, acceptedTerms } = structure;

  return (
    <div className="flex h-full flex-col gap-4">
      <div className="flex gap-2">
        <div className="flex self-center justify-center rounded-full bg-blue-50">
          <UserAvatar
            imgUrl={structureImageUrl ?? ""}
            name={businessName}
            className="size-[64px] md:size-[96px] select-none"
            avatarImgClassName="object-cover"
          />
        </div>
        <div className="flex flex-1 flex-col justify-end gap-1">
          <p className="text-3xl font-extrabold text-gray-900">{businessName}</p>
          <p className="text-lg text-gray-900 font-semibold">{businessSectorRelation?.name}</p>
        </div>
      </div>
      <StructureSocialsSection
        structure={structure}
        onSocialsClick={onSocialsClick}
      />
      {!isEmbedded && (
        <div className="flex items-center gap-2">
          {acceptedTerms && (
            <button
              onClick={() => (actionGuard ? actionGuard(onConversationClick) : onConversationClick())}
              className="flex items-center justify-center gap-2 rounded-lg bg-blue-500 px-4 py-2 text-base text-white"
            >
              <ChatCircleIcon width={24} height={24} fill={"white"} />
              Contacter
            </button>
          )}

          {onShareClick && (
            <button
              onClick={() => onShareClick()}
              className="border-primary-400 bg-primary-25 hidden items-center justify-center gap-2 rounded-lg border p-2 md:flex"
            >
              <ShareFatIcon className="text-primary-400 size-6" />
            </button>
          )}

          {toggleLike && !isNullish(isLiked) && (
            <button
              onClick={() => (actionGuard ? actionGuard(toggleLike) : toggleLike())}
              className="flex items-center justify-center gap-2 rounded-lg border border-amber-700 bg-amber-50 px-4 py-2 text-amber-700"
            >
              <HeartIcon className="size-6" weight={isLiked ? "fill" : "regular"} />
              Favoris
            </button>
          )}
        </div>
      )}
    </div>
  );
};
